import { forwardRef, type ImgHTMLAttributes } from 'react';

type ImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'width' | 'height'> & {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  // Compatibility props from the former image helper. Native <img> handles
  // loading/decoding directly; unsupported optimization hints are ignored.
  priority?: boolean;
  quality?: number;
  fill?: boolean;
  unoptimized?: boolean;
  placeholder?: string;
  blurDataURL?: string;
  loader?: unknown;
  sizes?: string;
};

const Image = forwardRef<HTMLImageElement, ImageProps>(function Image(
  { src, alt, width, height, priority, quality, fill, unoptimized, placeholder, blurDataURL, loader, sizes, style, ...rest },
  ref,
) {
  void quality;
  void unoptimized;
  void placeholder;
  void blurDataURL;
  void loader;
  const finalStyle = fill
    ? { position: 'absolute' as const, inset: 0, width: '100%', height: '100%', objectFit: 'cover' as const, ...style }
    : style;
  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      style={finalStyle}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      {...rest}
    />
  );
});

export default Image;
